
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/join/[slug]",
      function () {
        return require("private-next-pages/[locale]/guild/join/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/join/[slug]"])
      });
    }
  